import { ApplicationStatusEnum } from "../models/enum/application-status.enum";
import { SolicitorCaseStatusEnum } from "../models/enum/solicitor-case-status.enum";

export function getSolicitorCaseStatus(status: ApplicationStatusEnum, lodgementDate?: string | null): SolicitorCaseStatusEnum {
  switch (status) {
    case "SENT_TO_BIOME":
      return SolicitorCaseStatusEnum.pending_ipa;
    case "APPROVE":
    case "IPA_REVIEW_COMPLETE":
    case "REVIEW_FINANCIAL_PLAN":
    case "REVIEW_FINANCIAL_PLAN_COMPLETE":
    case "PREPARE_FOR_COMPLETION":
      return SolicitorCaseStatusEnum.ipa_received;
    case "APPLICATION_CANCELLED":
    case "CANCELLED":
      return SolicitorCaseStatusEnum.cancelled;
    case "APPLICATION_REJECTED":
    case "REJECTED":
      return SolicitorCaseStatusEnum.rejected;
    case "PREPARE_FOR_COMPLETION_COMPLETE":
      return lodgementDate ? SolicitorCaseStatusEnum.completed : SolicitorCaseStatusEnum.pending_lodgement;
    default:
      return SolicitorCaseStatusEnum.invalid;
  }
}

export function formatHdbRef(hdbRef: string) {
  return hdbRef.substring(0, 4) + "-" + hdbRef.substring(4, 8) + "-" + hdbRef.substring(8, 9) + "-" + hdbRef.substring(9);
}
